import React, {PureComponent} from 'react';
import {BrowserRouter as Router, Link, Route, Switch} from "react-router-dom";
import Navbar from 'react-bootstrap/Navbar';
import {withTranslation} from "react-i18next";
import Classes from '../../classes';
import Dashboard from '../../dashboard';
import Layout from '../../presentation';
import Multimedia from '../../multimedia';
import Connect from "react-redux/es/connect/connect";
import {logoutOauth} from "../../../actions";
import Button from 'react-bootstrap/Button';
import logo from '../../../assets/logo.png';
import menuNews from '../../../assets/menu-news.png';
import menuSchool from '../../../assets/menu-school.png';
import menuMultimedia from '../../../assets/menu-multimedia.png';
import menuPresentation from '../../../assets/presentation.png';
import arrowDown from '../../../assets/arrow-down.png';
import CreateNews from '../../news/create';
import CreateNewArticleMultimedia from '../../news/create/article';
import ApproveNews from '../../news/approve';
import ManageNews from '../../news/manage';
import {getItem, keys} from "../../../localStorage";
import {debug} from "../../../utility/functions";

class Index extends PureComponent {

	logout = () => {
		this.props.logoutOauth();
	};

	componentDidMount() {
		let path = window.location.pathname;
		path = path.substring(1, path.length);
		this.onNavButtonPressed(path);
	}

	openSideMenu = () => {
		let navMenu = document.getElementById("nav-menu");
		let navMenuInfo = document.getElementById("nav-menu-info");
		let navMenuButton = document.getElementById("nav-menu-side-menu");
		let sideMenu = document.getElementById("side-menu");
		let container = document.getElementById("container");

		navMenuButton.classList.add("open");
		navMenu.classList.add("open");
		sideMenu.classList.add("open");
		container.classList.add("open");
		navMenuInfo.classList.add("open");
	};

	closeSideMenu = () => {
		let navMenu = document.getElementById("nav-menu");
		let navMenuInfo = document.getElementById("nav-menu-info");
		let navMenuButton = document.getElementById("nav-menu-side-menu");
		let sideMenu = document.getElementById("side-menu");
		let container = document.getElementById("container");

		navMenuButton.classList.remove("open");
		navMenu.classList.remove("open");
		sideMenu.classList.remove("open");
		container.classList.remove("open");
		navMenuInfo.classList.remove("open");
	};

	isSideMenuOpen = () => {
		const navMenuButton = document.getElementById("nav-menu-side-menu");
		return navMenuButton.classList.contains('open');
	};

	openNewsMenu = () => {
		const newsArrow = document.getElementById("news-arrow");
		const newsMenu = document.getElementById("news-collapsed");
		const news = document.getElementById("news");
		const newsIndicator = document.getElementById("news-indicator");

		newsArrow.classList.add("arrow-down");
		newsArrow.classList.remove("arrow-up");
		newsMenu.classList.add("side-menu-body-li-opened");
		newsMenu.classList.remove("side-menu-body-li-collapsed");
		news.classList.add("active");
		newsIndicator.classList.add("side-menu-active");

	};

	closeNewsMenu = () => {
		const newsArrow = document.getElementById("news-arrow");
		const newsMenu = document.getElementById("news-collapsed");
		const news = document.getElementById("news");
		const newsIndicator = document.getElementById("news-indicator");
		newsArrow.classList.remove("arrow-down");
		newsArrow.classList.add("arrow-up");
		newsMenu.classList.remove("side-menu-body-li-opened");
		newsMenu.classList.add("side-menu-body-li-collapsed");
		news.classList.remove("active");
		newsIndicator.classList.remove("side-menu-active");
	};

	openMultimediaMenu = () => {
		const multimedia = document.getElementById("multimedia");
		const multimediaIndicator = document.getElementById("multimedia-indicator");
		multimedia.classList.add("active");
		multimediaIndicator.classList.add("side-menu-active");
	};

	closeMultimediaMenu = () => {
		const multimedia = document.getElementById("multimedia");
		const multimediaIndicator = document.getElementById("multimedia-indicator");
		multimedia.classList.remove("active");
		multimediaIndicator.classList.remove("side-menu-active");
	};

	openClassesMenu = () => {
		const classes = document.getElementById("classes");
		const classesIndicator = document.getElementById("classes-indicator");
		classesIndicator.classList.add("side-menu-active");
		classes.classList.add("active");
	};

	closeClassesMenu = () => {
		const classes = document.getElementById("classes");
		const classesIndicator = document.getElementById("classes-indicator");
		classesIndicator.classList.remove("side-menu-active");
		classes.classList.remove("active");
	};

	openPresentationMenu = () => {
		const presentation = document.getElementById("presentation");
		const presentationIndicator = document.getElementById("presentation-indicator");
		presentation.classList.add("active");
		presentationIndicator.classList.add("side-menu-active");

	};

	closePresentationMenu = () => {
		const presentation = document.getElementById("presentation");
		const presentationIndicator = document.getElementById("presentation-indicator");
		presentation.classList.remove("active");
		presentationIndicator.classList.remove("side-menu-active");
	};



	onNavButtonPressed = (navId) => {
		switch (navId) {
			case 'nav-menu-side-menu':
				if (this.isSideMenuOpen()) {
					this.closeSideMenu();
				} else {
					this.openSideMenu();
				}
				break;
			case 'news':
				this.openNewsMenu();
				this.closeMultimediaMenu();
				this.closeClassesMenu();
				this.closePresentationMenu();
				break;
			case 'news_child':
				this.closeSideMenu();
				break;
			case 'multimedia':
				this.openMultimediaMenu();
				this.closeNewsMenu();
				this.closeClassesMenu();
				this.closePresentationMenu();
				this.closeSideMenu();
				break;
			default:
				this.closeNewsMenu();
				this.closeMultimediaMenu();
				this.closeSideMenu();
				break;
		}

		if(getItem(keys.role) === "1") {
			switch (navId) {
				case 'classes':
					this.openClassesMenu();
					this.closeNewsMenu();
					this.closeMultimediaMenu();
					this.closePresentationMenu();
					this.closeSideMenu();
					break;
				case 'presentation':
					this.openPresentationMenu();
					this.closeNewsMenu();
					this.closeMultimediaMenu();
					this.closeClassesMenu()
					this.closeSideMenu();
					break;
				default:
					this.closeClassesMenu();
					this.closePresentationMenu();
					break;
			}
		}
	};

	render() {
		const {t} = this.props;
		return (
			<Router>
				<div>
					<div>
						<div className="menu">
							<div id="side-menu" className="side-menu">
								<div className="side-menu-header">
									<div className="side-menu-header-logo" onClick={() => this.onNavButtonPressed()}>
										<Link to="/">
											<img className="login-screen-logo-image" alt="logo" src={logo}/>
										</Link>
									</div>
								</div>
								<div className="side-menu-body">
									<li id="news" className="side-menu-body-li"
									    onClick={() => this.onNavButtonPressed('news')}>
										<div className="side-menu-body-li-select-indicator-div">
											<div id="news-indicator" className="side-menu-body-li-select-indicator">

											</div>
										</div>
										<div className="side-menu-body-icon-div">
											<i className="side-menu-body-icon">
												<img className="side-menu-body-icon-img" alt="news" src={menuNews}/>
											</i>
										</div>
										<div className="side-menu-body-text-div">
											{t('News')}
										</div>
										<div id="news-arrow" className="side-menu-body-ul-indicator-div arrow-up">
											<div className="side-menu-body-ul-indicator">
												<img className="side-menu-body-ul-indicator-img" alt="arrow icon"
												     src={arrowDown}/>
											</div>
										</div>
									</li>
									<div id="news-collapsed" className="side-menu-body-li-collapsed">
										<ul>
											<Link to="/create-news">
												<li
													className="side-menu-body-li-collapsed-li"
													onClick={() => this.onNavButtonPressed('news_child')}
												>
													<div className="side-menu-body-li-collapsed-title">
														{t('New News')}
													</div>
												</li>
											</Link>
											{getItem(keys.role) === '1' ?
												<Link to="/approve-news">
													<li
														className="side-menu-body-li-collapsed-li"
														onClick={() => this.onNavButtonPressed('news_child')}
													>
														<div className="side-menu-body-li-collapsed-title">
															{t('Approve News')}
														</div>
													</li>
												</Link>
												:
												false
											}
											<Link to="/manage-news">
												<li
													className="side-menu-body-li-collapsed-li"
												    onClick={() => this.onNavButtonPressed('news_child')}
												>
													<div className="side-menu-body-li-collapsed-title">
														{t('Management News')}
													</div>
												</li>
											</Link>
										</ul>
									</div>
									{getItem(keys.role) === '1' ?
										<Link to="/classes">
											<li id="classes" className="side-menu-body-li"
											    onClick={() => this.onNavButtonPressed('classes')}>
												<div className="side-menu-body-li-select-indicator-div">
													<div id="classes-indicator"
													     className="side-menu-body-li-select-indicator">

													</div>
												</div>
												<div className="side-menu-body-icon-div">
													<i className="side-menu-body-icon">
														<img className="side-menu-body-icon-img" alt="school"
														     src={menuSchool}/>
													</i>
												</div>
												<div className="side-menu-body-text-div">
													{t('Classes')}
												</div>
											</li>
										</Link>
										:
										false
									}
									<Link to="/multimedia">
										<li id="multimedia" className="side-menu-body-li"
										    onClick={() => this.onNavButtonPressed('multimedia')}>
											<div className="side-menu-body-li-select-indicator-div">
												<div id="multimedia-indicator"
												     className="side-menu-body-li-select-indicator">

												</div>
											</div>
											<div className="side-menu-body-icon-div">
												<i className="side-menu-body-icon">
													<img className="side-menu-body-icon-img" alt="multimedia"
													     src={menuMultimedia}/>
												</i>
											</div>
											<div className="side-menu-body-text-div">
												{t('Multimédia')}
											</div>
										</li>
									</Link>
									{getItem(keys.role) === '1' ?
										<Link to="/presentation">
											<li id="presentation" className="side-menu-body-li"
											    onClick={() => this.onNavButtonPressed('presentation')}>
												<div className="side-menu-body-li-select-indicator-div">
													<div id="presentation-indicator"
													     className="side-menu-body-li-select-indicator">
													</div>
												</div>
												<div className="side-menu-body-icon-div">
													<i className="side-menu-body-icon">
														<img className="side-menu-body-icon-img"
														     alt="presentation"
														     src={menuPresentation}/>
													</i>
												</div>
												<div className="side-menu-body-text-div">
													{t('Layouts')}
												</div>
											</li>
										</Link>
										:
										false
									}

								</div>
								<div className="side-menu-footer">
									<div className="side-menu-footer-logout">
										<Button onClick={() => this.logout()} variant="link">{t('Log out')}</Button>
									</div>
									<hr/>
									<div className="side-menu-footer-copywrite">
										{t('AÇORIANO ORIENTAL ') + '© ' + new Date().getFullYear()}
									</div>
								</div>
							</div>
							<div id="nav-menu" className="nav-menu">
								<Navbar variant="light" expand="lg">
									<div
										id="nav-menu-side-menu"
										onClick={() => this.onNavButtonPressed('nav-menu-side-menu')}
										className="nav-menu-side-menu"
									>
										<span></span>
										<span></span>
										<span></span>
									</div>
									<div id="nav-menu-info" className="nav-menu-info">
										<div className="nav-menu-info-school">
											<div className="info-school-value">
												{getItem(keys.name) ? getItem(keys.name) : false}
											</div>
											<div className="info-school-value">
												{getItem(keys.author) ? getItem(keys.author) : false}
											</div>
										</div>
										<div className="nav-menu-info-lective-year">
											<div
												className="info-lective-year-value">{getItem(keys.yearInfo) ? getItem(keys.yearInfo) : false}</div>
										</div>
									</div>
								</Navbar>
							</div>
						</div>
						<div id="container" className="container">
							{getItem(keys.role) === '1' ? <Switch>
									<Route exact path="/create-news" component={CreateNews}/>
									<Route exact path="/create-news/multimedia"
									       component={(props) => <CreateNewArticleMultimedia  {...props}
									                                                          mode={"normal"}/>}/>
									<Route exact path="/create-news/gallery"
									       component={(props) => <CreateNewArticleMultimedia {...props}
									                                                         mode={"gallery"}/>}/>
									<Route exact path="/approve-news" component={ApproveNews}/>
									<Route exact path="/manage-news" component={ManageNews}/>
									<Route path="/classes" component={Classes}/>
									<Route path="/multimedia" component={Multimedia}/>
									<Route path="/presentation" component={Layout}/>
									<Route component={Dashboard}/>
								</Switch> :
								<Switch>
									<Route exact path="/create-news" component={CreateNews}/>
									<Route exact path="/create-news/multimedia"
									       component={(props) => <CreateNewArticleMultimedia {...props}
									                                                         mode={"normal"}/>}/>
									<Route exact path="/create-news/gallery"
									       component={(props) => <CreateNewArticleMultimedia {...props}
									                                                         mode={"gallery"}/>}/>
									<Route exact path="/approve-news" component={ApproveNews}/>
									<Route exact path="/manage-news" component={ManageNews}/>
									<Route path="/multimedia" component={Multimedia}/>
									<Route component={Dashboard}/>
								</Switch>
							}

						</div>
					</div>
				</div>
			</Router>
		)
	}
}

const mapStateToProps = store => ({
	loggedIn: store.loginReducer.loggedIn,
});

const mapFunctionsToProps = {
    logoutOauth
};

export default (Connect(mapStateToProps, mapFunctionsToProps)(withTranslation("translations")(Index)));
